



























import { Vue, Component } from "vue-property-decorator";

@Component
export default class ClientDefaultLayout extends Vue {
  public get hasBillboard() {
    return !!this.$scopedSlots.billboard;
  }

  public get hasMenu() {
    return !!this.$scopedSlots.menu;
  }
}
